import React, { memo } from 'react';
import PropTypes from 'prop-types';

const SingleValueChartComponent = ({ value }) => {
  return <span className="h2 font-weight-bold mb-0">{value}</span>;
};

SingleValueChartComponent.propTypes = {
  value: PropTypes.number.isRequired,
};

export default memo(SingleValueChartComponent);
